import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import { first } from 'lodash';
import uuid from 'uuid/v4';
import Root from '../../components/root';
import store from '../../store/index';

export default class ElementWithPopover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.elementUniqueClassName = `popover-element-${uuid()}`;
    this.popoverUniqueClassName = `popover-${uuid()}`;

    this.hideOnClick = this.hideOnClick.bind(this);
    this.showPopover = this.showPopover.bind(this);
    this.hidePopover = this.hidePopover.bind(this);
    this.linkAction = this.linkAction.bind(this);
  }

  componentDidMount() {
    const constraints = this.props.constraints.map(({ elem, pin }) => (
      { to: window.jQuery(elem)[0], pin }
    ));

    this.element().popover({
      template: this.renderPopoverTemplate(),
      trigger: this.props.trigger,
      html: true,
      placement: this.props.placement,
      constraints,
    });
  }

  get contentWithRoot() {
    return (
      <Root store={store}>
        {this.props.content}
      </Root>
    );
  }

  getClassName() {
    return `${this.props.name}-popover-element`;
  }

  getPopoverClassName() {
    return `${this.props.name}-popover`;
  }

  linkAction() {
    this.props.linkAction();
    this.hidePopover();
  }

  hidePopover() {
    window.hidePopoverTimeout = window.setTimeout(() => {
      this.element().popover('hide');
      this.setState({ visible: false });
      document.body.removeEventListener('click', this.hideOnClick);
    }, 150);
  }

  hideOnClick(ev) {
    const parent = this.popoverElement();
    if (!parent || parent.contains(ev.target)) return null;
    if (ev.target === this.element()[0]) return null;
    if (this.element()[0].contains(ev.target)) return null;
    return this.hidePopover();
  }

  isVisible() {
    return this.state.visible === true;
  }

  element() {
    return window.jQuery(`.${this.elementUniqueClassName}`);
  }

  popoverElement() {
    const elements = document.getElementsByClassName(this.popoverUniqueClassName);
    return first(elements);
  }

  bindPopoverInternalLinksClickEvent() {
    const { actionLink } = this.props;
    if (!actionLink) return;

    const link = first(document.getElementsByClassName(actionLink));
    link.addEventListener('click', this.linkAction);
  }

  bindPopoverHideTriggers() {
    const popover = first(document.getElementsByClassName(`${this.props.name}-popover`));
    popover.addEventListener('mouseenter', () => {
      window.clearTimeout(window.hidePopoverTimeout);
    });
    popover.addEventListener('mouseleave', this.hidePopover);
  }

  showPopover() {
    if (this.isVisible()) return;
    document.body.addEventListener('click', this.hideOnClick);
    this.element().popover('show');
    this.bindPopoverInternalLinksClickEvent();
    this.bindPopoverHideTriggers();
    this.setState({ visible: true });
  }

  renderPopoverTemplate() {
    const className = `${this.getPopoverClassName()} ${this.popoverUniqueClassName}`;
    return `
      <div class="popover pbg-popover ${className}" role="tooltip">
        <div class="popover-content"></div>
      </div>'
    `;
  }

  render() {
    const className = `${this.getClassName()} ${this.elementUniqueClassName}`;
    return (
      <div
        href={`#${this.props.name}`}
        className={`${className} clear-blue ${this.props.className}`}
        data-animation="false"
        data-toggle="popover"
        html={this.contentWithRoot}
        data-content={renderToString(this.contentWithRoot)}
        onMouseEnter={this.showPopover}
        onMouseLeave={this.hidePopover}
      >
        {this.props.children}
      </div>
    );
  }
}

ElementWithPopover.defaultProps = {
  placement: 'bottom',
  trigger: 'manual',
  constraints: [],
  className: '',
  actionLink: null,
  linkAction: () => {},
};




// WEBPACK FOOTER //
// ./src/desktop/components/element-with-popover.js